import { render, staticRenderFns } from "./EnvironmentHealth.vue?vue&type=template&id=2de7bc80&"
import script from "./EnvironmentHealth.vue?vue&type=script&lang=js&"
export * from "./EnvironmentHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports